import React, {
  Fragment,
} from 'react'

import {
  Button,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string,
  object,
  bool,
} from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

function CtaButton({
  text,
  trackText,
  href,
  className = '',
  linkAttributes = EMPTY_OBJECT,
  useLinkComponent = false,
  useLinkIcon = false,
  buttonSize = 'large',
}) {
  if (useLinkComponent) {
    return (
      <a
        className={classnames('js-track-cta-click', className)}
        href={href}
        {...linkAttributes}
        data-track-text={trackText}
      >
        {text}
        {useLinkIcon && (
          <Fragment>
            {' '}
            <Icon type={['far', 'chevron-right']} notSpaced />
          </Fragment>
        )}
      </a>
    )
  }

  return (
    <Button
      href={href}
      linkAttributes={{
        ...linkAttributes,
        'data-track-text': trackText,
      }}
      size={buttonSize}
      customClass={classnames('js-track-cta-click', className)}
    >
      {text}
    </Button>
  )
}

CtaButton.propTypes = {
  text: string.isRequired,
  trackText: string.isRequired,
  href: string.isRequired,
  linkAttributes: object,
  useLinkComponent: bool,
  useLinkIcon: bool,
  className: string,
  buttonSize: string,
}

export default CtaButton
